<template>
    <h1>404 Nerasta</h1>
</template>

<script>

export default({
    name: 'notFoundScreen',
    emits: [ 'triggerModal' ],
    screen: true
})
</script>
